import { Component, ElementRef, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseClass } from '../../utility/baseClass';
import { VALIDATION_PATTERNS } from '../../utility/validation-patterns';
import { Utilityservice } from '../../utility/utilityservice.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { Entityservice } from '../../main-layout/entity/entityservice';
import * as moment from 'moment';

@Component({
  selector: 'app-legalmodifyentitymodal',
  templateUrl: './legalmodifyentitymodal.component.html',
  styleUrls: ['./legalmodifyentitymodal.component.css']
})
export class LegalmodifyentitymodalComponent extends BaseClass {
  companyId: String;
  requestform: FormGroup;
  errorDIsplay = false;
  filterinput = new Filterreq();
  existingdetails: any = {};
  saveTitle = 'Add';
  CSRFToken = '';
  tempentity: any;
  constructor(
    private utilityservice: Utilityservice,
    private fb: FormBuilder,
    public config: DynamicDialogConfig,
    public override injector: Injector,
    private Entityservice: Entityservice,
    private el: ElementRef,
    public ref: DynamicDialogRef,

  ) {
    super(injector);
    const dataFromParent = this.config.data;
    this.gettoken();
    if (dataFromParent?.title === 'Modify Legal Name of Entity') {
      this.saveTitle = 'Modify';
      this.existingdetails = dataFromParent.datas;
    }
  }


  gettoken() {
    this.CSRFToken = '';
    this.utilityservice.getCSRFtoken().subscribe(res => {
      this.CSRFToken = res.csrf;
    }, error => {
      Swal.fire(error.error.message, '', 'error');
    });
  }

  ngOnInit() {
    this.formInitiliaze();
     
      this.patchValueForms(this.existingdetails[0]);
  }

  patchValueForms(data) {
    this.requestform.patchValue({
      'entityname': data?.companyname,
      'entityinitial': data?.companyinitial
    });
  }




  add() {
    if (this.requestform.invalid) {
      this.validateAllFormFields(this.requestform, this.el);
      return;
    }


    Swal.fire({
      title: "Do you want to save the changes?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Save",
      denyButtonText: `Don't Save`
    }).then((value) => {
      let data = this.requestform.value;
      if (value.isConfirmed) {
        
        const payload = {
          fromdate: this.filtersData['tfromdate'],
          csrftoken: this.CSRFToken,
          entityname: this.requestform.get('entityname')?.value,
          entityinitial: this.requestform.get('entityinitial')?.value,
          entityid: this.existingdetails[0].companyid
        };
         
         
        data['csrftoken'] = this.CSRFToken
        this.Entityservice.legalchange(payload).subscribe((data) => {
          this.tempentity = data;
          console.log(this.tempentity, 'line 131')
          if (this.tempentity.response == 'Exists') {
            Swal.fire("Entity name already exists", " ", "error").then(result => {
              this.ref.close()
            });
          } else {
            Swal.fire("Saved!", "", "success").then(result => {
              this.ref.close('Save');
            });
          }
        }, error => {
          Swal.fire({
            icon: "error",
            title: error.error.error,
            footer: "Error status is: " + error.status
          });
        });
      } else if (value.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });


  }

  formInitiliaze() {
    this.requestform = this.fb.group({
      entityname: ['', Validators.compose([Validators.required,
      Validators.maxLength(100),
      Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICTDISALLOWSTARTENDSPACE),
      Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
      Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW)

      ])],
      fromdate: ['', Validators.required],
      entityinitial: ['', Validators.compose([Validators.required,
      Validators.maxLength(100),
      Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICTDISALLOWSTARTENDSPACE),
      Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
      Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW)
      ])]
    });

  }


  public validation_message = {
    entityname: [
      { type: 'required', message: 'Entity Name is required.' },
      { type: 'SPACERISTRICTDISALLOWSTARTENDSPACE', message: 'Space is not allowed at the beginning or end' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: `Special character not allowed (% and ')` },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' },
    ],
    entityinitial: [
      { type: 'required', message: 'Entity initial is required.' },
      { type: 'SPACERISTRICTDISALLOWSTARTENDSPACE', message: 'Space is not allowed at the beginning or end' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: `Special character not allowed (% and ')` },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' },
    ],
    fromdate: [
      { type: 'required', message: 'From Date is required.' }
       
    ]

  }

  filtersData = {
    tfromdate: '',
  }

  onclear(event) {
    if (event.fromdate == null) {
      this.errorDIsplay = false;
      this.filtersData['tfromdate'] = '';
    }
  }


  onDateChange(event: any): void {
    if (event) {
      this.filterinput.fromdate = event;
      this.filtersData['tfromdate'] = moment(event).format('YYYY-MM-DD');
      this.requestform.get('fromdate')?.setValue(event); 
    } else {
      Swal.fire({
        icon: 'warning',
        text: 'Please select from date',
      });
    }
  }

  getdates(event) {
    if (!event.fromdate) {
      Swal.fire({
        icon: 'warning',
        text: 'Please select From Date',
      });
    }
    if (event.fromdate !== '') {
      if (event.fromdate <= event.todate) {
        this.errorDIsplay = false;
        this.filtersData['fromdate'] = moment(event.fromdate).format('YYYY-MM-DD');
      } else {
        this.errorDIsplay = true;
      }
    }
  }

}
export class Filterreq {
  fromdate: string = '';
}